import dayjs from 'dayjs';
import {
  TAutoCompleteOptions,
  TDepots,
  TEnterprise,
} from '../types';

export const capitalizeFirstLetter = (
  s: string | undefined
) => {
  return s?.replace(/^.{1}/g, s[0].toUpperCase());
};

export const downLoadLink = (
  responseFileUrl: string | undefined
) => {
  if (responseFileUrl) {
    const downloadLink = document.createElement('a');
    downloadLink.href = responseFileUrl;
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
};

export const getLabelByIdFromList = (
  id: number | string,
  list: TAutoCompleteOptions[] | undefined
) => list?.find((ele) => ele.value === id)?.label || '-';

export const getFormattedDepots = (
  depots: TDepots[] | undefined
) =>
  depots?.map((plant) => ({
    value: plant.plantCode,
    label: `${plant.plantName} [${plant.plantCode}]`,
  }));

export const checkRetailerDetailsAccess = (
  enterpriseList: TEnterprise[]
) => {
  const allowedEnterprise = [1, 2, 3];
  const hasAccess = enterpriseList.find((enterprise) =>
    allowedEnterprise.includes(enterprise.id)
  )
    ? true
    : false;
  localStorage.setItem(
    'retailerInfoAccess',
    hasAccess.toString()
  );
  return hasAccess;
};

export const getFormattedDate = (
  date: Date | null | undefined,
  format: string = 'DD-MM-YYYY'
) => (date ? dayjs(date).format(format) : date);

export const formatNumber = (
  number: string | undefined | null,
  options?: Intl.NumberFormatOptions | undefined
) => {
  return number
    ? new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
        ...options,
      }).format(parseFloat(number))
    : number;
};

export const subtractDays = (days: string) => {
  const dateObject = new Date();
  // Set the time to the start of the day (00:00:00)
  dateObject.setHours(0, 0, 0, 0);

  // Subtract the specified number of days from the current date
  dateObject.setDate(dateObject.getDate() - parseInt(days));

  // Get the time in milliseconds
  const milliseconds = dateObject.getTime();

  return milliseconds / 1000;
};
